
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.333 15.25V5.333H11.75c-.97 0-1.75.78-1.75 1.75v33.834c0 .97.78 1.75 1.75 1.75h24.5c.97 0 1.75-.78 1.75-1.75V17h-9.917c-.962 0-1.75-.788-1.75-1.75zM38 14.222v.445h-9.333V5.333h.444c.467 0 .912.183 1.24.51l7.139 7.147c.328.328.51.772.51 1.232z","fill":"#535353"}})])
          )
        }
      }
    